module.exports = __webpack_public_path__ + "static/media/clubs.4f3fb941.svg";